module.exports = __webpack_public_path__ + "static/media/AutoCAD Architecture.d3ed0e67.png";